import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Image } from '@fiverr-private/media';
import { Typography } from '@fiverr-private/typography';
import { appTranslate } from '../../../i18n';
import { STANDALONE_ONBOARDING_IMAGE } from './constants';

export const OnboardingBanner = () => (
    <Container position="relative" height="100%" maxHeight="100%" borderRadius="2xl" overflow="hidden">
        <Container
            position="absolute"
            alignSelf="flexEnd"
            padding="10"
            paddingTop="0"
            background="linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.90) 100%)"
            width="100%"
            minHeight="40%"
            overflow="hidden"
            display="flex"
        >
            <Typography color="white" size={{ default: 'h_4xl', xl: 'h_5xl' }} alignSelf="flexEnd" width="100%">
                {appTranslate<string>('identification.banner.title')}
            </Typography>
        </Container>

        <Image
            alt={appTranslate<string>('identification.banner.image_alt')}
            objectFit="cover"
            height="100%"
            maxWidth="100%"
            maxHeight="100%"
            width="auto"
            src={STANDALONE_ONBOARDING_IMAGE}
            htmlWidth="480"
            htmlHeight="711"
        />
    </Container>
);
